import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VListItem,{style:(_vm.itemStyle)},[_c('div',{staticStyle:{"width":"32px","display":"flex","justify-content":"center"},on:{"click":function($event){_vm.$router.push(_vm.item.routeTo).catch((error) => {
          if (
            error.name !== 'NavigationDuplicated' &&
            !error.message.includes(
              'Avoided redundant navigation to current location'
            )
          ) {
            _vm.console.log(error);
          }
        })}}},[_c(VIcon,{class:_vm.active ? 'sidebar-active-icon' : 'sidebar-icon'},[_vm._v(_vm._s(_vm.item.icon))])],1),_c(VListItemContent,{on:{"click":function($event){_vm.$router.push(_vm.item.routeTo).catch((error) => {
          if (
            error.name !== 'NavigationDuplicated' &&
            !error.message.includes(
              'Avoided redundant navigation to current location'
            )
          ) {
            _vm.console.log(error);
          }
        })}}},[_c(VListItemTitle,{class:_vm.active ? 'sidebar-active-text' : 'sidebar-text',staticStyle:{"margin-right":"20px"}},[_vm._v(_vm._s(_vm.item.text))])],1),(_vm.item.childItems)?_c(VIcon,{staticClass:"sidebar-icon",style:(_vm.iconStyle),on:{"click":function($event){_vm.openChildList = !_vm.openChildList}}},[_vm._v("fa-chevron-down")]):_vm._e()],1),_c(VSlideYTransition,[(_vm.item.childItems && _vm.openChildList)?_c(VList,{staticStyle:{"padding":"0"}},_vm._l((_vm.item.childItems),function(item,i){return _c('item',{key:i,attrs:{"item":item,"level":_vm.level + 1}})}),1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }